// extracted by mini-css-extract-plugin
module.exports = {"Container":"vehicle-card-image-desktop_Container__eDHAo","Image":"vehicle-card-image-desktop_Image__AGbvA"};